import { render } from "./InfoPage.vue?vue&type=template&id=668ed844&scoped=true"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"

import "./InfoPage.vue?vue&type=style&index=0&id=668ed844&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668ed844"]])

export default __exports__